import { EnvironmentName } from '../../../environments/types/environment.type';
import { Domain } from '../auth/user-access.model';

export type TargetEnvironment = 'local' | 'dev' | 'staging' | 'prod';
type TargetEnvironmentMapping = Readonly<Record<EnvironmentName, TargetEnvironment>>;

export const DEFAULT_TARGET_ENVIRONMENTS: TargetEnvironmentMapping = {
  local: 'staging',
  ci: 'staging',
  dev: 'staging',
  staging: 'staging',
  prod: 'prod',
};

export const DOMAIN_TARGET_ENVIRONMENTS: Readonly<Record<Domain, TargetEnvironmentMapping>> = {
  EXCESS_RETURN: DEFAULT_TARGET_ENVIRONMENTS,
  EXCESS_RETURN_ADMIN: DEFAULT_TARGET_ENVIRONMENTS,
  SASI: DEFAULT_TARGET_ENVIRONMENTS,
  USER_MANAGEMENT: {
    ...DEFAULT_TARGET_ENVIRONMENTS,
    local: 'local',
    dev: 'dev',
  },
  CENTRAL_ROUTING: {
    ...DEFAULT_TARGET_ENVIRONMENTS,
    local: 'dev',
    dev: 'dev',
  },
  OPERATIONS: {
    ...DEFAULT_TARGET_ENVIRONMENTS,
    local: 'local',
    dev: 'dev',
  },
  STOCKLOCATOR: DEFAULT_TARGET_ENVIRONMENTS,
};

export function targetEnvironmentFor(
  environment: EnvironmentName,
  domain: Domain | undefined,
): TargetEnvironment {
  if (environment === 'prod') {
    return 'prod';
  }

  return (domain ? DOMAIN_TARGET_ENVIRONMENTS[domain] : DEFAULT_TARGET_ENVIRONMENTS)[environment];
}
